/**
 * @module log
 * @description 系統日誌相關型別定義
 */
/** 日誌等級（6 級） */
export var LogLevel;
(function (LogLevel) {
    LogLevel["DEBUG"] = "DEBUG";
    LogLevel["INFO"] = "INFO";
    LogLevel["NOTICE"] = "NOTICE";
    LogLevel["WARNING"] = "WARNING";
    LogLevel["ERROR"] = "ERROR";
    LogLevel["CRITICAL"] = "CRITICAL";
})(LogLevel || (LogLevel = {}));
/** 日誌分類（8 類） */
export var LogCategory;
(function (LogCategory) {
    LogCategory["AUTH"] = "AUTH";
    LogCategory["USER"] = "USER";
    LogCategory["ROLE"] = "ROLE";
    LogCategory["TOURNAMENT"] = "TOURNAMENT";
    LogCategory["MEMBER"] = "MEMBER";
    LogCategory["ACCOUNTING"] = "ACCOUNTING";
    LogCategory["SYSTEM"] = "SYSTEM";
    LogCategory["SECURITY"] = "SECURITY";
})(LogCategory || (LogCategory = {}));
//# sourceMappingURL=log.js.map